import React, { useEffect, useRef, useState } from 'react'

// Mirrors bennes-crm-api's order-form.embed.ts snippet: the form measures its
// own body height and posts it here, since a fixed height clips the taller
// second step or leaves a gap under the shorter first one.
const ORDER_FORM_INITIAL_HEIGHT = 720
const ORDER_FORM_RESIZE_MESSAGE = 'bennecrm:order-form:height'

// Posted once the server has saved a request, with the saved request as
// `detail` (id, amount excluding VAT, currency). Pushed to GTM, where the
// Google Ads conversion tag fires on this event.
const ORDER_FORM_SUBMITTED_MESSAGE = 'bennecrm:order-form:submitted'
const GTM_ORDER_SUBMITTED_EVENT = 'bennecrm_order_submitted'

const trackOrderSubmitted = (request = {}) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: GTM_ORDER_SUBMITTED_EVENT,
    orderValue: request.amount || 0,
    orderCurrency: request.currency || 'EUR',
    orderId: request.id || '',
  })
}

const OrderForm = () => {
  const frameRef = useRef(null)
  const [height, setHeight] = useState(ORDER_FORM_INITIAL_HEIGHT)

  useEffect(() => {
    const onMessage = event => {
      if (
        !frameRef.current ||
        event.source !== frameRef.current.contentWindow
      ) {
        return
      }

      const data = event.data
      if (!data) {
        return
      }

      if (data.type === ORDER_FORM_RESIZE_MESSAGE) {
        setHeight(data.height)
      } else if (data.type === ORDER_FORM_SUBMITTED_MESSAGE) {
        trackOrderSubmitted(data.detail)
      }
    }

    window.addEventListener('message', onMessage)

    return () => window.removeEventListener('message', onMessage)
  }, [])

  return (
    <div className="inputForm home_order_form" style={{ padding: 0 }}>
      <iframe
        ref={frameRef}
        data-bennecrm-order-form
        src="https://api.bennecrm.com/api/v1/public/order-form/uFfTNlAgj3AwIaB-vUamJQEFvXW851fI/embed?lang=fr"
        title="Passer commande"
        loading="lazy"
        style={{
          display: 'block',
          width: '100%',
          height: `${height}px`,
          border: 'none',
        }}
      ></iframe>
    </div>
  )
}

export default OrderForm
